import React, { useState } from "react";
import ProjectSelector from "./components/ProjectSelector";
import BimViewer from "./components/BimViewer";

export default function DigiTwin() {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (file) => setSelectedFile(file);
  const handleBack       = () => setSelectedFile(null);

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {!selectedFile ? (
        <ProjectSelector onFileSelect={handleFileSelect} />
      ) : (
        <BimViewer file={selectedFile} onBack={handleBack} />
      )}
    </div>
  );
}
